import React, { useState } from 'react';
import { Button, Container, Row, Col } from 'react-bootstrap';
import EntryBlock from './EntryBlock';
import saveIcon from '../../../Assets/Icons/Generic/save.png';

const EntriesList = ({ upcomingTitle, upcomingNote, onListNotes, onSaveNotes }) => {
  const [messages, setMessages] = useState([]);

  const addMessage = () => {
    setMessages((prevMessages) => [
      ...prevMessages,
      {
        // Unique identifier for each message
        id: prevMessages.length + 1,
        title: upcomingTitle,
        content: upcomingNote,
      },
    ]);
    handleOnListNotes();
  };

  const removeMessage = (id) => {
    setMessages((prevMessages) =>
      prevMessages.filter((message) => message.id !== id)
    );
  };

  const handleOnListNotes = () => {
    //  Execute passed funtion (intended to clear text area).
    if (onListNotes) {
      onListNotes();
    }
  };

  function transformData(inputData) {
    let generalNote = ""; // Initialize general_note
    const teethMap = new Map(); // Use a Map to consolidate teeth notes by ID
  
    try {
      inputData.forEach((item) => {
        // Check if it's a general note (no ID in the title)
        if (!item.title.includes(":")) {
          generalNote = generalNote
            ? `${generalNote}\n\n${item.content}` // Append content as a new paragraph
            : item.content; // Set the initial general note
          return; // Skip further processing for general notes
        }
  
        // Extract ID from the title
        const id = parseInt(item.title.split(":")[0].trim(), 10);
        const parts = item.title
          // Extract the part after the colon
          .split(":")[1]
          // Remove parentheses
          .replace(/[()]/g, "")
          // Split into sections
          .split(",")
          // Trim each section name
          .map((section) => section.trim());
  
        // Map parts into the required format
        const newSections = parts.reduce((acc, part) => {
          const lowerPart = part.toLowerCase();
          acc[lowerPart] = {
            description: item.content,
            statuses: [0],
          };
          return acc;
        }, {});
  
        // Check if the tooth ID already exists in the map
        if (teethMap.has(id)) {
          const existingTooth = teethMap.get(id);
          Object.entries(newSections).forEach(([section, newData]) => {
            // Merge descriptions as paragraphs if the section already exists
            if (existingTooth[section]) {
              existingTooth[section].description += `\n\n${newData.description}`;
            } else {
              // Add new section
              existingTooth[section] = newData;
            }
          });
        } else {
          // Add a new tooth entry to the map
          teethMap.set(id, newSections);
        }
      });
  
      // Convert Map to array
      const teethNotes = Array.from(teethMap, ([id, sections]) => ({ id, ...sections }));
  
      return {
        general_note: generalNote,
        teeth_notes: teethNotes,
      };
    } catch (error) {
      console.error("Error processing data:", error);
      return {
        general_note: "Error processing data",
        teeth_notes: [],
      };
    }
  }
  
  const handleOnSaveNotes = () => {
    const transformedData = transformData(messages);
  
    console.log("Transformed Data:", transformedData);
  
    // Execute passed function (intended to save data into API)
    if (onSaveNotes) {
      onSaveNotes(transformedData); // Pass the transformed data
    }
  
    // Clear notes list once they're saved
    setMessages([]);
  };
  

  return (
    <Container>
      <Row>
        <Col xs={1}>
          {/* Add to list */}
          <Button
            onClick={addMessage}
            style={styles.addButton}
          >
            →
          </Button>
        </Col>
        <Col xs={10}>
          {/* Message list container */}
          <div style={styles.container}>
            <div style={styles.messageList}>
              {messages.map((message) => (
                <EntryBlock
                  key={message.id}
                  title={message.title}
                  content={message.content}
                  onRemove={() => removeMessage(message.id)}
                />
              ))}
            </div>
          </div>
        </Col>
        <Col xs={1}>
          {/* Save notes */}
          <Button
            onClick={handleOnSaveNotes}
            style={styles.saveButton}
          >
            <img
              src={saveIcon}
              alt="Save"
              style={styles.image}
            />
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

const styles = {
  container: {
    height: '300px', // Fixed height for the message display container
    border: '1px solid #ddd',
    borderRadius: '10px',
    overflow: 'hidden', // Ensure the container has no overflow
  },
  messageList: {
    height: '100%', // Fill the available height
    overflowY: 'scroll', // Enable vertical scrolling
    padding: '10px',
    minHeight: '0px',
  },
  addButton: {
    width: '100%', // Make the button fill the column width
    height: '300px', // Match the height of the message container
    borderRadius: '10px', // Same rounded corners as the container
    padding: '0px',
  },
  saveButton: {
    backgroundColor: '#4CAF50', // Adjust the color as needed
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center', // Centers the image horizontally
    alignItems: 'center', // Centers the image vertically
    width: '100%', // Make the button fill the column width
    height: '300px', // Match the height of the message container
    padding: '0', // Remove any padding for precise image alignment
  },
  image: {
    width: '20px', // Adjust the width of the image as needed
    height: '20px', // Adjust the height of the image as needed
  },
};

export default EntriesList;
